document.addEventListener('DOMContentLoaded', function () {
    const slider = document.querySelector('.category-slider');
    if (!slider) return;

    const wrapper = slider.querySelector('.category-slider__wrapper');
    const slides = wrapper.querySelectorAll('.category-slide');
    const prevBtn = slider.querySelector('.category-slider__nav--prev');
    const nextBtn = slider.querySelector('.category-slider__nav--next');

    const slidesToShow = parseInt(slider.dataset.slidesMobile) || 4;
    const totalSlides = slides.length;

    let currentIndex = slidesToShow; // Start after clones
    let isTransitioning = false;
    let isDragging = false;
    let startX = 0;
    let initialTransform = 0;

    // Create clones for infinite scrolling
    function createClones() {
        wrapper.querySelectorAll('.category-slide-clone').forEach(clone => clone.remove());

        if (totalSlides <= slidesToShow) return;

        // Clone last slides at beginning and first slides at end
        for (let i = totalSlides - slidesToShow; i < totalSlides; i++) {
            const clone = slides[i].cloneNode(true);
            clone.classList.add('category-slide-clone');
            wrapper.insertBefore(clone, wrapper.firstChild);
        }

        for (let i = 0; i < slidesToShow; i++) {
            const clone = slides[i].cloneNode(true);
            clone.classList.add('category-slide-clone');
            wrapper.appendChild(clone);
        }
    }

    // Update slider position
    function updateSlider(instant = false, customTransform = null) {
        const slideWidth = 100 / slidesToShow;
        const translateX = customTransform ?? -(currentIndex * slideWidth);

        wrapper.querySelectorAll('.category-slide, .category-slide-clone')
            .forEach(slide => slide.style.flex = `0 0 ${slideWidth}%`);

        wrapper.style.transition = instant ? 'none' : 'transform 0.3s ease';
        wrapper.style.transform = `translateX(${translateX}%)`;

        if (instant) wrapper.offsetHeight; // Force reflow

        // Update nav buttons
        const hasEnoughSlides = totalSlides > slidesToShow;
        [prevBtn, nextBtn].forEach(btn => {
            if (btn) {
                btn.style.opacity = hasEnoughSlides ? '1' : '0.5';
                btn.style.pointerEvents = hasEnoughSlides ? 'auto' : 'none';
            }
        });
    }

    // Navigate slides
    function navigate(direction) {
        if (isTransitioning || totalSlides <= slidesToShow) return;

        isTransitioning = true;
        currentIndex += direction;
        updateSlider();

        setTimeout(() => {
            // Handle infinite loop
            if (currentIndex >= totalSlides + slidesToShow) {
                currentIndex = slidesToShow;
                updateSlider(true);
            } else if (currentIndex < slidesToShow) {
                currentIndex = totalSlides;
                updateSlider(true);
            }
            isTransitioning = false;
        }, 300);
    }

    // Drag functionality
    const getEventX = e => e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
    let currentX = 0;

    function handleDragStart(e) {
        if (isTransitioning || totalSlides <= slidesToShow) return;

        isDragging = true;
        startX = currentX = getEventX(e);
        initialTransform = -(currentIndex * (100 / slidesToShow));
        wrapper.style.transition = 'none';

        if (e.type.includes('touch')) e.preventDefault();
    }

    function handleDragMove(e) {
        if (!isDragging) return;

        e.preventDefault();
        currentX = getEventX(e);
        const dragPercentage = ((currentX - startX) / wrapper.offsetWidth) * 100;
        updateSlider(false, initialTransform + dragPercentage);
    }

    function handleDragEnd() {
        if (!isDragging) return;

        isDragging = false;
        wrapper.style.transition = 'transform 0.3s ease';

        if (totalSlides <= slidesToShow) {
            updateSlider();
            return;
        }

        const slideWidth = wrapper.offsetWidth / slidesToShow;
        currentIndex = Math.round(currentIndex - ((currentX - startX) / slideWidth));

        updateSlider();

        setTimeout(() => {
            if (currentIndex >= totalSlides + slidesToShow) {
                currentIndex = slidesToShow;
                updateSlider(true);
            } else if (currentIndex < slidesToShow) {
                currentIndex = totalSlides;
                updateSlider(true);
            }
        }, 300);
    }

    // Event listeners
    nextBtn?.addEventListener('click', () => navigate(1));
    prevBtn?.addEventListener('click', () => navigate(-1));

    wrapper.addEventListener('mousedown', handleDragStart);
    wrapper.addEventListener('touchstart', handleDragStart, { passive: false });
    document.addEventListener('mousemove', handleDragMove);
    document.addEventListener('touchmove', handleDragMove, { passive: false });
    document.addEventListener('mouseup', handleDragEnd);
    document.addEventListener('touchend', handleDragEnd);

    wrapper.addEventListener('contextmenu', e => isDragging && e.preventDefault());
    window.addEventListener('resize', () => updateSlider());

    // Initialize
    createClones();
    updateSlider(true);
});